module.exports = __webpack_public_path__ + "static/media/021.94b6c272.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/021.jpg
// module id = 494
// module chunks = 0